import { CurrencyAmount, JSBI } from '../sdk'
import { getNativeGasReserveRaw } from '../config/nativeGasReserve'
import { getNativeChainIdForCurrency } from '../config/native'

/**
 * Máximo gastable de un saldo: ERC-20 completo; nativo menos reserva de gas por cadena.
 */
export function maxAmountSpend(currencyAmount?: CurrencyAmount): CurrencyAmount | undefined {
  if (!currencyAmount) return undefined
  const nativeChainId = getNativeChainIdForCurrency(currencyAmount.currency)
  if (nativeChainId !== undefined) {
    const reserve = getNativeGasReserveRaw(nativeChainId)
    if (JSBI.greaterThan(currencyAmount.raw, reserve)) {
      return CurrencyAmount.native(nativeChainId, JSBI.subtract(currencyAmount.raw, reserve))
    }
    return CurrencyAmount.native(nativeChainId, JSBI.BigInt(0))
  }
  return currencyAmount
}
